import React, {useMemo} from 'react';
import {Bar} from 'react-chartjs-2';
import ChartContainer from '../chartContainer';
import {formatNumberToDisplayWithCommas} from '../../../../../common/shared';
import {getMonthlyChartLabels} from '../../chartLabelHelpers';
import '../chartSetup';

const HeadcountPerShiftChart = ({chartData}) => {
    const items = chartData.items;
    const labels = useMemo(() => getMonthlyChartLabels(items), [items]);
    const values = useMemo(() => items.map(item => item.overage), [items]);
    const targetDataset = useMemo(() => items.map(item => item.target), [items]);

    const data = useMemo(() => ({
        labels: labels,
        datasets: [
            {
                type: 'bar',
                data: values,
                backgroundColor: '#bfbfbf',
                order: 2,
                label: 'Headcount Overage',
            },
            {
                type: 'line',
                data: targetDataset,
                backgroundColor: '#c00000',
                borderColor: '#c00000',
                order: 1,
                label: 'Target',
            }
        ],
    }), [labels, targetDataset, values]);

    const options = useMemo(() => ({
        scales: {
            y: {
                title: 'Headcount Overage',
                beginAtZero: true,
            },
            x: {
                grid: {
                    drawOnChartArea: false,
                    tickLength: 10,
                },
                ticks: {
                    autoSkip: false,
                    maxRotation: 45,
                    minRotation: 0,
                }
            },
        },
        plugins: {
            legend: {
                reverse: true,
            },
            tooltip: {
                callbacks: {
                    label: function(context) {
                        if (context.dataset.type === 'bar') {
                            const item = items[context.dataIndex] || {};
                            return [
                                `Overage: ${formatNumberToDisplayWithCommas(item.overage, 0)}`,
                                `Day: ${formatNumberToDisplayWithCommas(item.overage_day, 0)}`,
                                `Night: ${formatNumberToDisplayWithCommas(item.overage_night, 0)}`,
                            ];
                        }

                        let label = context.dataset.label || '';
                        if (label) {
                            label += ': ';
                        }
                        if (context.parsed.y !== null) {
                            label += formatNumberToDisplayWithCommas(context.parsed.y, 0);
                        }
                        return label;
                    }
                }
            },
        },
        maxBarThickness: 40,
    }), [items])

    const summaryItems = [
        {
            label: 'Period Overage Day',
            value: formatNumberToDisplayWithCommas(chartData.period_overage_day, 0),
        },
        {
            label: 'Period Overage Night',
            value: formatNumberToDisplayWithCommas(chartData.period_overage_night, 0),
        },
        {
            label: 'Current Target',
            value: formatNumberToDisplayWithCommas(chartData.target, 0),
        },
    ];

    return (
        <ChartContainer title="Headcount Per Shift" summaryItems={summaryItems}>
            <Bar data={data} options={options}/>
        </ChartContainer>
    )
}

export default HeadcountPerShiftChart;
